import { render, staticRenderFns } from "./ProjectMasterDataTab.vue?vue&type=template&id=5850a121"
import script from "./ProjectMasterDataTab.vue?vue&type=script&lang=js"
export * from "./ProjectMasterDataTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectMasterDataTab.vue?vue&type=style&index=0&id=5850a121&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports